import { render, staticRenderFns } from "./SearchCertificate.vue?vue&type=template&id=6e3124d2&scoped=true"
import script from "./SearchCertificate.vue?vue&type=script&lang=js"
export * from "./SearchCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3124d2",
  null
  
)

export default component.exports